import React from "react";
import { Modal, Button } from "react-bootstrap";

export const ErrorDialog = ({
  header,
  message,
  closeButtonText,
  handleClose,
  centered = true,
}) => {
  return (
    <Modal show onHide={handleClose} animation={false} centered={centered}>
      {header && (
        <Modal.Header className="bg-danger text-white" closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer className='py-1'>
        <Button variant="primary" className='py-1' onClick={handleClose}>
          {closeButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorDialog;
